import { BaseModel } from "./base/base.model";
import { UserA3LRelations } from "./userA3LRelations";

export class User extends BaseModel {
  public UserName!: string;
  public Password?: string;
  public ConfirmPassword?: string;
  public Name!: string;
  public Surname!: string;
  public Email!: string;
  public IsDeleted?: boolean;
  public IdCliente!: string;
  public PhoneNumber?: string;
  public Roles?: string[];
  public A3LCompanies?: UserA3LRelations[]
}

